import {
  FETCH_HISTORYLIST_REQUEST,
  FETCH_HISTORYLIST_SUCCESS,
  FETCH_HISTORYLIST_FAILURE,
} from "./historyListTypes";
import api from "../../utils/Api";
import axios from 'axios';

export const fetchHistoryListRequest = () => {
  return {
    type: FETCH_HISTORYLIST_REQUEST,
  };
};

export const fetchHistoryListSuccess = (historyList) => {
  return {
    type: FETCH_HISTORYLIST_SUCCESS,
    payload: historyList,
  };
};

export const fetchHistoryListFailure = (error) => {
  return {
    type: FETCH_HISTORYLIST_FAILURE,
    payload: error,
  };
};

const CancelToken = axios.CancelToken;
let cancelRequest;
export const fetchHistoryList = (searchKey, sortBy, page, isScheduledPayment) => {
   //cancel previous request if multiple hits done.
   cancelRequest && cancelRequest();
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  let url = "payment/trasaction/history/fetch?search_key=" + searchKey + "&sort_by=" + sortBy + "&page=" +  page;
  if(isScheduledPayment){
    url += "&isScheduledPayment="+isScheduledPayment;
  }
  return async (dispatch) => {
    dispatch(fetchHistoryListRequest());
    try {
      const response = await api.get(
        url,
        {
          headers: headers,
          cancelToken: new CancelToken(function executor(c) {
            cancelRequest = c;
        })
        }
      );
      const historyList = response.data.data;
      dispatch(fetchHistoryListSuccess(historyList));
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Error: ', error.message); // => prints: Api is being canceled
      } 
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchHistoryListFailure(errorMsg));
    }
  };
};
